import React from 'react'
import PopUp from '../index'
import hammerIcon from './../../../assets/images/Google-hammer-icon.png'
import crossIcon from './../../../assets/images/cross.png'
import { styles } from '../styles'
import { withTranslation } from 'react-i18next'
import { TFunction } from 'i18next'

interface PopupsProps {
  t: TFunction
  open: boolean
  handleClose: any
}

const PinExtensionPopup = ({ t, open, handleClose }: PopupsProps) => {
  const classes = styles()

  return (
    <PopUp
      open={open}
      title={
        <>
          <img
            src={hammerIcon}
            alt={t('popUps.imageAlts.hammer')}
            className={classes.imageContainer}
          />
          <div className={classes.textContainer}>
            {t('popUps.text.rememberToPin')}
          </div>
          <button className={classes.closeButton} onClick={handleClose}>
            <img
              src={crossIcon}
              alt={t('popUps.imageAlts.close')}
              className={classes.closeButton}
            />
          </button>
        </>
      }
      placement="top"
      customStyle={classes.pinExtensionPopUpPosition}
    >
      <div></div>
    </PopUp>
  )
}

export default withTranslation()(PinExtensionPopup)
